import * as types from './action-types';

const defaultState = {
    isDisplayed: false,
    message: '',
    type: 'fail', // 'success', 'info', 'fail'
    // Counter increments on each new alert, allowing component to detect replacements
    alertId: 0,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.SHOW_ALERT:
        return {
            ...state,
            isDisplayed: true,
            message: action.message,
            type: action.alertType || 'fail',
            alertId: state.alertId + 1,
        };

    case types.DISMISS_ALERT:
        return {
            ...state,
            isDisplayed: false,
            message: '',
        };

    default:
        return state;
    }
};

export default reducer;
